import React, { useEffect, useState } from 'react';
import { LibraryObjectType } from '@fullstory/routes';
import { intl } from '@fullstory/intl';
import { ObjectType } from '@fullstory/proto/fs/services/dx-objects';
import { NameModal } from './NameModal';

export const RenameModal: React.FC<{
  onCloseSignal: () => void;
  type: LibraryObjectType;
  name: string;
  description: string;
  onSubmit: (name: string, description: string) => void;
  open: boolean;
}> = ({ onCloseSignal, type, name, onSubmit, description, open }) => {
  const [newName, setNewName] = useState(name);
  const [newDescription, setNewDescription] = useState(description);
  const [error, setError] = useState('');

  // copy props changes to local state
  useEffect(() => {
    setNewName(name);
  }, [name]);
  useEffect(() => {
    setNewDescription(description);
  }, [description]);

  const handleOnSubmit = () => {
    if (!newName) {
      setError(intl.formatMessage({ defaultMessage: 'Name is required', id: 'Gvxoji' }));
    } else {
      setError('');
      onSubmit(newName, newDescription);
    }
  };

  const messages = renameModalMessages[type];

  return (
    <NameModal
      data-component="RenameModal"
      title={messages.title}
      value={newName}
      description={newDescription}
      buttonText={messages.buttonText}
      error={error}
      onChange={setNewName}
      onChangeDescription={setNewDescription}
      onSubmit={handleOnSubmit}
      onCloseSignal={onCloseSignal}
      open={open}
    />
  );
};

const renameModalMessages: {
  [key in LibraryObjectType]: { title: string; buttonText: string };
} = {
  [ObjectType.FUNNEL]: {
    title: intl.formatMessage({ defaultMessage: 'Rename Funnel as...', id: 'BiPOHv' }),
    buttonText: intl.formatMessage({ defaultMessage: 'Rename Funnel', id: 'P9vhU8' }),
  },
  [ObjectType.HEATMAP]: {
    title: intl.formatMessage({ defaultMessage: 'Rename Heatmap as...', id: '+z+GpG' }),
    buttonText: intl.formatMessage({ defaultMessage: 'Rename Heatmap', id: 'JUGf03' }),
  },
  [ObjectType.JOURNEY]: {
    title: intl.formatMessage({ defaultMessage: 'Rename Journey as...', id: 'LNG2M/' }),
    buttonText: intl.formatMessage({ defaultMessage: 'Rename Journey', id: 'J6Ub2v' }),
  },
  [ObjectType.METRIC]: {
    title: intl.formatMessage({ defaultMessage: 'Rename Metric as...', id: 'mCQrAN' }),
    buttonText: intl.formatMessage({ defaultMessage: 'Rename Metric', id: 'LyYZWY' }),
  },
  [ObjectType.RETENTION]: {
    title: intl.formatMessage({ defaultMessage: 'Rename Retention as...', id: 'SrlvZ7' }),
    buttonText: intl.formatMessage({ defaultMessage: 'Rename Retention', id: 'xFRTqg' }),
  },
  [ObjectType.SEGMENT]: {
    title: intl.formatMessage({ defaultMessage: 'Rename Segment as...', id: 'biPIZT' }),
    buttonText: intl.formatMessage({ defaultMessage: 'Rename Segment', id: 'W60Pw+' }),
  },
  [ObjectType.DASHBOARD]: {
    title: intl.formatMessage({ defaultMessage: 'Rename Dashboard as...', id: 'vS+ifm' }),
    buttonText: intl.formatMessage({ defaultMessage: 'Rename Dashboard', id: 'RAbPUb' }),
  },
  [ObjectType.DATA_TABLE]: {
    title: intl.formatMessage({ defaultMessage: 'Rename Data Table as...', id: 'VzUpEA' }),
    buttonText: intl.formatMessage({ defaultMessage: 'Rename Data Table', id: '4ztavv' }),
  },
};
